import { BASE_URL } from "../constant/constant";

export const filterExplorerData = (data, filters) => {
  if (!filters.tags || !filters.tags.length) return data;

  return data.map((device) => {
    const deviceCopy = JSON.parse(JSON.stringify(device));
    deviceCopy.items = filterItemsRecursively(deviceCopy.items, filters.tags);
    return deviceCopy;
  });
};

const filterItemsRecursively = (items, tagIds) => {
  return items.filter((item) => {
    if (item.isFolder) {
      item.items = filterItemsRecursively(item.items, tagIds);
      return item.items.length > 0;
    } else {
      return tagIds.some((tagId) => item.fileInfo?.info_tag?.includes(tagId));
    }
  });
};

export const organizeScreenFolders = (prevData, screenItem, device, folderInfoTag, folderTagsData, screenId = null) => {
  let originalFolderId = null;
  let originalPositionInFolder = -1;
  let wasUntagged = false;
  let originalPositionInUntagged = -1;

  const deviceMap = {
    desktop: 0,
    mobile: 1,
    tablet: 2
  };

  if (screenId) {
    // const deviceIndex = device === "desktop" ? 0 : 1;
    const deviceIndex = deviceMap[device] ?? 0;
    const deviceFolder = prevData[deviceIndex];

    deviceFolder.items.forEach((item) => {
      if (item.isFolder && item.items) {
        const screenIndex = item.items.findIndex((subItem) => subItem.id === screenId);
        if (screenIndex !== -1) {
          originalFolderId = item.id;
          originalPositionInFolder = screenIndex;
        }
      }
    });

    if (!originalFolderId) {
      const untaggedItems = deviceFolder.items.filter((item) => !item.isFolder);
      originalPositionInUntagged = untaggedItems.findIndex((item) => item.id === screenId);
      if (originalPositionInUntagged !== -1) {
        wasUntagged = true;
      }
    }
  }

  const newFolderId = folderInfoTag?.length > 0 ? `${device}-${folderInfoTag[0]}` : null;
  const sameFolder = originalFolderId === newFolderId;
  const stayingUntagged = wasUntagged && !newFolderId;

  return prevData.map((deviceFolder, index) => {
    // const deviceIndex = device === "desktop" ? 0 : 1;
    const deviceIndex = deviceMap[device] ?? 0;
    if (index !== deviceIndex) return deviceFolder;

    const updatedDeviceFolder = { ...deviceFolder, items: [...deviceFolder.items] };

    const folders = updatedDeviceFolder.items.filter((item) => item.isFolder);
    const untaggedItems = updatedDeviceFolder.items.filter((item) => !item.isFolder);

    if (screenId) {
      folders.forEach((folder) => {
        const screenIndex = folder.items?.findIndex((item) => item.id === screenId);
        if (screenIndex !== -1) {
          folder.items.splice(screenIndex, 1);
        }
      });

      const untaggedIndex = untaggedItems.findIndex((item) => item.id === screenId);
      if (untaggedIndex !== -1) {
        untaggedItems.splice(untaggedIndex, 1);
      }
    }

    if (folderInfoTag?.length > 0) {
      const folderId = folderInfoTag[0];
      const folderIndex = folders.findIndex((item) => item.id === `${device}-${folderId}`);

      if (folderIndex !== -1) {
        if (sameFolder && originalPositionInFolder !== -1) {
          const insertPos = Math.min(originalPositionInFolder, folders[folderIndex].items.length);
          folders[folderIndex].items.splice(insertPos, 0, screenItem);
        } else {
          folders[folderIndex].items.push(screenItem);
        }
      } else {
        const folderData = folderTagsData.find((tag) => tag.id === folderId);
        const folderName = folderData ? folderData.name : `Folder ${folderId}`;

        const newFolder = {
          id: `${device}-${folderId}`,
          name: folderName,
          isFolder: true,
          items: [screenItem],
          isOpen: true,
          can_delete: true
        };

        folders.push(newFolder);
      }
    } else {
      if (stayingUntagged && originalPositionInUntagged !== -1) {
        const insertPos = Math.min(originalPositionInUntagged, untaggedItems.length);
        untaggedItems.splice(insertPos, 0, screenItem);
      } else {
        untaggedItems.push(screenItem);
      }
    }

    updatedDeviceFolder.items = [...folders, ...untaggedItems];
    return updatedDeviceFolder;
  });
};
export const getAllScreens = (items) => {
  return items.reduce((acc, item) => {
    if (item.isFolder && item.items) {
      return [...acc, ...getAllScreens(item.items)];
    } else if (!item.isFolder) {
      return [...acc, item];
    }
    return acc;
  }, []);
};

export const getLogoUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http") || src.startsWith("https")) {
    return src;
  }
  return `${BASE_URL}/api/v1/public/${src}`;
};
